// @ts-check
/**
 * timeline.js — the single source of truth for the scroll narrative's
 * story-progress timeline.
 *
 * Story progress t ∈ [0, 1] spans the whole pinned experience:
 *   - Hero occupies t ∈ [0, HERO_T_END]
 *   - The runway owns t ∈ [HERO_T_END, HERO_T_END + RUNWAY_T_SPAN]
 *
 * Inside the runway, local progress r ∈ [0, 1] is segmented into halls,
 * dark handoff gaps and the coda (RUNWAY_SEG). Consumers:
 *   - main.js            hero/runway t-mapping + chapter-rail thresholds
 *   - gallery-runway.js  corridor translateX + hall interiors + jump targets
 *   - spirit-stage.js    spirit & light keyframe tracks (via r2t)
 *
 * When hall counts or segment boundaries change, edit THIS file only.
 */

/** Hero occupies story t ∈ [0, 0.16]. */
export const HERO_T_END = 0.16;

/** Runway owns t ∈ [0.16, 0.93]; the remaining tail is the about/contact exit. */
export const RUNWAY_T_SPAN = 0.77;

/** Story t where the runway ends (≈ 0.93). */
export const RUNWAY_T_END = HERO_T_END + RUNWAY_T_SPAN;

/**
 * Runway segments in r-space: hall / handoff-gap alternation plus coda.
 * @type {Record<string, number[]>}
 */
export const RUNWAY_SEG = {
  hall1: [0.0, 0.26],
  move1: [0.26, 0.34],
  hall2: [0.34, 0.56],
  move2: [0.56, 0.64],
  hall3: [0.64, 0.88],
  coda: [0.88, 1.0],
};

/**
 * Hall centers in runway r-space (index-aligned with the halls array from
 * exhibitions.json). Used for chapter-rail / hero-card jump targets.
 */
export const HALL_CENTERS = [0.13, 0.45, 0.76];

/**
 * Rail activation boundaries: midpoints between adjacent hall centers, so the
 * rail highlight flips exactly halfway between two halls.
 * Derived from HALL_CENTERS — never hardcode.
 */
export const HALL_BOUNDARIES = HALL_CENTERS.slice(1).map(
  (center, i) => (center + HALL_CENTERS[i]) / 2
);

/**
 * Maps runway-local progress r ∈ [0, 1] to story progress t.
 * @param {number} r
 */
export function r2t(r) {
  return HERO_T_END + r * RUNWAY_T_SPAN;
}
